const DRAWER_TRANSITION = { duration: 0.3, ease: [0.32, 0.72, 0, 1] } as const;
// Radix keeps the page non-interactive until the menu's exit finishes, so leaving is quicker than arriving.
const DRAWER_EXIT_TRANSITION = { duration: 0.2, ease: [0.32, 0.72, 0, 1] } as const;
const DISMISS_DISTANCE = 96;
const DISMISS_VELOCITY = 500;

export { DISMISS_DISTANCE, DISMISS_VELOCITY, DRAWER_EXIT_TRANSITION, DRAWER_TRANSITION };
